/**
 *
 * This file was automatically generated using build-icons npm script and should not be edited
 * 
 **/
import { createIcon } from "@v2/helpers/icons/create-icon";
export const NoDataIcon = createIcon({
  displayName: "NoDataIcon",
  viewBox: "0 0 16 16",
  path: (<g fill="none"><path fillRule="evenodd" clipRule="evenodd" d="M6.9394 7.99908L2.46973 3.52941L3.53039 2.46875L8.00006 6.93842L12.4697 2.46875L13.5304 3.52941L9.06072 7.99908L13.5304 12.4688L12.4697 13.5294L8.00006 9.05974L3.53039 13.5294L2.46973 12.4688L6.9394 7.99908Z" fill="currentColor" /></g>)
});